import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'picking.showSendToPacking'.
 * Styrer om knappen «Til pakking» (Avslutt og send til pakking) vises i plukkmodulen.
 *
 * Tenkt for tenanter som ikke benytter pakkemodulen — sett til false for å skjule knappen.
 * Settes på systemnivå (AllowProfileLevel=false), men hooket bruker getEffectiveSetting
 * slik at et eventuelt fremtidig profilnivå respekterer hierarkiet (Profile → System → Default).
 *
 * Default: true (bakoverkompatibelt — knappen vises med mindre den eksplisitt skjules).
 */
export function useShowSendToPacking(): boolean {
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('picking.showSendToPacking');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setShow(val === 'true' || val === '1' || val === 'ja');
          } else {
            // Ingen verdi satt → bruk default (vis knappen)
            setShow(true);
          }
        }
      } catch (err) {
        console.warn('Could not load picking.showSendToPacking setting, defaulting to true:', err);
        if (!cancelled) {
          setShow(true);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return show;
}
